import React from "react";
import PaymentResultPage from "./PaymentResultPage";

export default function PaymentSuccessPage() {
  return (
    <PaymentResultPage
      kind="success"
      title="Paiement reçu avec succès."
      message="Votre règlement a bien été pris en compte. Nous avons enregistré votre commande et le suivi sera mis à jour automatiquement."
      hint="Vous pouvez maintenant retrouver votre devis, son statut de paiement et les prochaines étapes depuis votre espace client."
    />
  );
}
